module.exports = __webpack_public_path__ + "static/img/9.9dc2734.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/sp/9.png
// module id = QzS4
// module chunks = 0